import { useAxiosModule } from '@/modules/_shared/axios'
import * as types from './types'

export const TRIAL_FORMS_CONTEXT = 'trial-forms'

const { postToApi, getFromApi, putToApi, patchToApi } = useAxiosModule()

export type GetFreeFormsListResponse = types.FreeFormsListResponse

export async function getFreeForms (search = '', sortBy = 'id desc', limit = 0, offset = 0) {
    const queryParams = new URLSearchParams()
    queryParams.set('search', search)
    queryParams.set('sort', sortBy)
    queryParams.set('limit', String(limit))
    queryParams.set('offset', String(offset))
    const url = 'subscription-forms?' + queryParams.toString()
    return getFromApi<GetFreeFormsListResponse>(url)
}

export type GetFreeFormResponse = types.FreeForm
export async function getFreeForm (formId: string) {
    return getFromApi<GetFreeFormResponse>(`subscription-forms/${formId}`)
}

export type AddFreeFormRequest = types.AddFreeForm
export async function addFreeForm (req: AddFreeFormRequest) {
    return postToApi<null>('subscription-forms/', req)
}

/* Get available translation domains */

export type GetTranslationDomainsListResponse = types.TranslationDomainsList
export async function availableTranslationDomains () {
    return await getFromApi<GetTranslationDomainsListResponse>(`translations/contexts/${TRIAL_FORMS_CONTEXT}/domains`)
}

/* Get domain translations */

export type GetTranslationDomainTranslationsResponse = types.TranslationDomainTranslations[]
export const getTranslationDomainTranslations = async (domain: string) =>
    await getFromApi<GetTranslationDomainTranslationsResponse>(`translations/contexts/${TRIAL_FORMS_CONTEXT}/domains/${domain}/translations`)

/* Add new translation domain */

export type AddTranslationDomainRequest = types.AddTranslationDomain
export const addTranslationDomain = async (req: AddTranslationDomainRequest) =>
    await postToApi<null>(`translations/contexts/${TRIAL_FORMS_CONTEXT}/domains`, req)

/* Update name */

export type UpdateFreeFormNameRequest = types.ChangeFreeFormName
export const updateFreeFormName = async (formId: string, req: UpdateFreeFormNameRequest) =>
    await putToApi<null>(`subscription-forms/${formId}/name`, req)

/* Update slug */

export type UpdateFreeFormSlugRequest = types.ChangeFreeFormSlug
export const updateFreeFormSlug = async (formId: string, req: UpdateFreeFormSlugRequest) =>
    await putToApi<null>(`subscription-forms/${formId}/slug`, req)

/* Update description translation */

export type UpdateFreeFormDescriptionTranslationRequest = types.ChangeFreeFormDescriptionTranslation
export const updateFreeFormDescription = async (formId: string, req: UpdateFreeFormDescriptionTranslationRequest) => {
    await putToApi<null>(`subscription-forms/${formId}/description-translation`, req)
}

/* Update access allow after */

export type UpdateFreeFormAllowAfterRequest = types.ChangeFreeFormAllowAfter
export const updateFreeFormAllowAfter = async (formId: string, req: UpdateFreeFormAllowAfterRequest) =>
    await putToApi<null>(`subscription-forms/${formId}/allow-after`, req)

/* Update packages */

export type UpdateFreeFormPackagesRequest = types.ChangeFreeFormPackages
export const updateFreeFormPackages = async (formId: string, req: UpdateFreeFormPackagesRequest) =>
    await putToApi<null>(`subscription-forms/${formId}/packages`, req)

/* Update end date */

export type UpdateFreeFormEndDateRequest = types.ChangeFreeFormEndDate
export const updateFreeFormEndDate = async (formId: string, req: UpdateFreeFormEndDateRequest) =>
    await putToApi<null>(`subscription-forms/${formId}/end-date`, req)

/* Update access duration */

export type UpdateFreeFormAccessDurationRequest = types.ChangeFreeFormAccessDuration
export const updateFreeFormAccessDuration = async (formId: string, req: UpdateFreeFormAccessDurationRequest) =>
    await putToApi<null>(`subscription-forms/${formId}/access-duration`, req)

/* Enable free form */

export const enableFreeForm = async (formId: string) =>
    patchToApi(`subscription-forms/${formId}/enable`, { formId: formId })

/* Disable free form */

export const disableFreeForm = async (formId: string) =>
    patchToApi(`subscription-forms/${formId}/disable`, { formId: formId })
